<template lang="pug">
  include ./../../vuek/mixins.pug

  +b.H2.t-h2(:class="{ 'isWhite': white }")
    slot
</template>

<script>
export default {
  name: 't-h2',

  props: {
    white: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
@import '../../scss/styles';

.t-h2 {
  color: $color-blue;
  margin: 0;
  text-transform: uppercase;

  &.isWhite {
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TH2/TH2.vue